export default __webpack_public_path__ + "static/media/img_no_records.0455a4c8.png";